import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { DataService } from '@app/services/data.service';
import { map } from 'rxjs/operators';
import * as selector from '@app/marketplace/products/state/shopping-cart/cart-selectors';
import {Observable} from 'rxjs';
import {Store} from '@ngrx/store';
import {isPlatformBrowser} from '@angular/common';
import {StorageService} from '@app/services/storage.service';

@Injectable()
export class CheckoutMarketGuard implements CanActivate {

  shoppingCart$: Observable<any>;
  constructor(private router: Router, private storageService: StorageService) {
  }
  canActivate() {
    const shoppingStore = this.storageService.getSavedState('basket');
    if (shoppingStore.data.items.length > 0) {
      return true;
    } else {
      this.router.navigate(['/market/productos-compras-cuba-online']);
      return false;
    }
  }
}
